import PropTypes from 'prop-types';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import * as Styled from './Carousel.style';
import { ProgressBar } from './ProgressBar';

function CarouselControls({
  handleNextButtonOnClick = () => {},
  handlePrevButtonOnClick = () => {},
  progressState = {},
}) {
  const { sizes } = useBreakpoints();

  return (
    <Styled.Controls role="group" aria-label="Slide controls">
      <Styled.PrevButtonContainer>
        {sizes.isMobile && (
          <Styled.IconButton label="go to previous slide" onClick={handlePrevButtonOnClick}>
            <ArrowBackRoundedIcon />
          </Styled.IconButton>
        )}
      </Styled.PrevButtonContainer>
      <Styled.ProgressBarContainer>
        <ProgressBar
          autoplayDuration={progressState.autoplayDuration}
          currentSlide={progressState.currentSlide}
          isAutoplay={progressState.isAutoplay}
          totalSlides={progressState.totalSlides}
        />
      </Styled.ProgressBarContainer>
      <Styled.NextButtonContainer>
        {!sizes.isMobile && (
          <Styled.IconButton
            clickstreamProps={{
              elementName: 'carousel_change',
              elementText: 'previous',
            }}
            label="go to previous slide"
            onClick={handlePrevButtonOnClick}
          >
            <ArrowBackRoundedIcon />
          </Styled.IconButton>
        )}
        <Styled.IconButton
          clickstreamProps={{
            elementName: 'carousel_change',
            elementText: 'next',
          }}
          label="go to next slide"
          onClick={handleNextButtonOnClick}
        >
          <ArrowForwardRoundedIcon />
        </Styled.IconButton>
      </Styled.NextButtonContainer>
    </Styled.Controls>
  );
}

CarouselControls.propTypes = {
  handlePrevButtonOnClick: PropTypes.func,
  handleNextButtonOnClick: PropTypes.func,
  progressState: PropTypes.shape({
    autoplayDuration: PropTypes.number,
    currentSlide: PropTypes.number,
    isAutoplay: PropTypes.bool,
    totalSlides: PropTypes.number,
  }),
};

export default CarouselControls;
